/**
 * --------------------------------------------------------------------------
 * Basic Modules: SearchBar.js
 * --------------------------------------------------------------------------
 */

import ClearFields from "./ClearFields";
import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'searchBar';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
    KEY_UP              : `keyup${EVENT_KEY}`,
    CHANGE              : `change${EVENT_KEY}`,
    MOUSEDOWN           : `mousedown${EVENT_KEY}`,
    FOCUS               : `focus${EVENT_KEY}`,
    BLUR                : `blur${EVENT_KEY}`,
};

const ClassName = {
    HOME: 'page-template-home',
    ACTIVE: 'active',
    SEARCH_OPENED: 'search-opened',
};

const Selector = {
    TOGGLE              : `[data-toggle="${NAME}"]`,
    SEARCH_INPUT        : '.js-search-input',
    SEARCH_SUBMIT       : '.js-search-submit',
    BTN_CLEAR           : '.js-search-clear',
};

const DataAttr = {
    SEARCH_OPENED: 'search-opened',
    SEARCH_CLOSED: 'search-closed',
};

class SearchBar {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.i = true;
        this.s = false;
        this.scrollInitialized = false;

        this._element = element;
        this._config  = this._getConfig(config);

        this.$searchInput  = $(this._element).find(Selector.SEARCH_INPUT);
        this.$searchSubmit = $(this._element).find(Selector.SEARCH_SUBMIT);

        this._setup();

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private


    _setup() { // o()
        DEBUG && console.log(LOG_KEY, 'Search Input', this.$searchInput);
        this.$searchInput.clearFields();
        this.u();
        this.a();
        this.f();
    }

    u() {
        this._clearSearchInput();
        if (Util.$pageWrapper.hasClass(ClassName.HOME) || Util.viewport === 'mobile' || Util.viewport === 'phablet') {
            this.i = true;
        }
        else {
            this.i = false;
        }
    }

    a() {
        this.$searchSubmit.on(Event.MOUSEDOWN, () => {
            this.s = true;
        });

        this.$searchSubmit.on(Event.CLICK, (e) => {
            e.preventDefault();
            this.i ? this.$searchInput.val() !== "" ? $(this._element).find('form').submit() : this.h() : this.c();
            this.s = false;
        });
    }

    f() {
        this.$searchInput.on(Event.FOCUS, () => {
            this.i || this.c();
        });

        this.$searchInput.on(Event.BLUR, () => {
            this.i && this.$searchInput.val() === "" && !this.s && this.h();
        });
    }

    _clearSearchInput() { // l()
        this.$searchInput.val("");
    }

    // Open search input
    c() {
        this.$searchSubmit.attr("title", $(this._element).data(DataAttr.SEARCH_OPENED));
        this.$searchSubmit.html($(this._element).data(DataAttr.SEARCH_OPENED));
        $(this._element).addClass(ClassName.SEARCH_OPENED);
        this.i = true;
        this.$searchInput.focus();
    }

    // Close search input
    h() {
        this.$searchSubmit.attr("title", $(this._element).data(DataAttr.SEARCH_CLOSED));
        this.$searchSubmit.html($(this._element).data(DataAttr.SEARCH_CLOSED));
        $(this._element).removeClass(ClassName.SEARCH_OPENED);
        $(this._element).find(Selector.BTN_CLEAR).removeClass(ClassName.ACTIVE);
        this._clearSearchInput();
        this.i = false;
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.
        this.u();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        SearchBar._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new SearchBar(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = SearchBar._jQueryInterface;
$.fn[NAME].Constructor = SearchBar;


export default SearchBar;
